import { render, staticRenderFns } from "./TrendsPage.vue?vue&type=template&id=2a0a116a"
import script from "./TrendsPage.vue?vue&type=script&lang=ts"
export * from "./TrendsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports